﻿export const projectSettings = {
    phoneNumber: (window.projectSettings && window.projectSettings.phoneNumber) || "",
    emailAddress: (window.projectSettings && window.projectSettings.emailAddress) || "",
    classActionName: (window.projectSettings && window.projectSettings.classActionName) || "",
    serviceUrl: (window.projectSettings && window.projectSettings.serviceUrl) || "",
    agreementUrl: (window.projectSettings && window.projectSettings.agreementUrl) || "",
    gSiteKey: (window.projectSettings && window.projectSettings.gSiteKey) || "",
}

export const referralTypes = [
    { name: "Advertising" },
    { name: "Client" },
    { name: "Online" },
    { name: "Family/Friend" },
    { name: "Professional Referral" },
    { name: "Staff Referral" },
    { name: "Media" },
    { name: "Word of Mouth" },
    { name: "Other" },
];

export const salutationTypes = [
    { name: "Dr" },
    { name: "Mr" },
    { name: "Miss" },
    { name: "Ms" },
    { name: "Mrs" },
    { name: "Other" },
];

export const yesNoOptions = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
];

export const yesNoWarningOptions = [
    { label: "Yes", value: "Yes" },
    { label: "No *", value: "No" },
];

export const yesNoBooleanOptions = [
    { label: "Yes", value: true },
    { label: "No *", value: false },
];

export const yesNoUnsureOptions = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
    { label: "Unsure", value: "Unsure" },
];

export const individualCapacityTypes = [
    { name: "Trustee" },
    { name: "Agent" },
    { name: "Legal Representative" },
];

export const companyCapacityTypes = [
    { name: "Director" },
    { name: "Secretary" },
    { name: "Authorised signatory" },
];

export const smsfCapacityTypes = [
    { name: "Trustee" },
    { name: "Authorised signatory" },
    { name: "Agent" },
];

export const instoCapacityTypes = [
    { name: "Trustee" },
    { name: "Authorised signatory" },
    { name: "Agent" },
];

export const claimantCapacityTypes = [
    { name: "Employee" },
    { name: "Director" },
    { name: "Secretary" },
];

export const acceptedFileUploadList = "application/pdf,.csv,image/*,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/docx,application/pdf,text/plain,application/msword,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const holdingTransactionTypeList = [
    'Buy',
    'Sell',
];
